import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { Icons } from '../../../../shared/helpers/icons';
import { UserDataService } from '../../../../shared/services/userData.service';
import { ISevereWeatherLocation } from '../../../../shared/models/severeWeatherLocation';
import { SevereWeatherLocationService } from '../../../../shared/services/severeWeatherLocation.service';

@Component({
  selector: 'severe-weather-form',
  standalone: true,
  imports: [CommonModule, FormsModule, LucideAngularModule, SpinnerComponent],
  templateUrl: './severe-weather-form.component.html'
})
export class SevereWeatherFormComponent implements OnInit {

  icons = Icons;

  @Input() itemToEdit: ISevereWeatherLocation | null = null;

  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<{ type: string, message: string }>();

  currentBuildingId: string | null = null;
  entry: ISevereWeatherLocation = {};
  loading: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private severeWeatherLocationService: SevereWeatherLocationService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.entry = this.itemToEdit ? { ...this.itemToEdit } : {};
  }

  get isEdit(): boolean {
    return !!this.itemToEdit?.id;
  }

  get isValid(): boolean {
    return !!this.entry.location;
  }

  closeModal(): void {
    this.onClose.emit();
  }

  save(): void {
    if (!this.currentBuildingId || !this.isValid) return;

    const payload: Partial<ISevereWeatherLocation> = { location: this.entry.location };

    this.loading = true;
    const request$ = this.isEdit
      ? this.severeWeatherLocationService.updateSevereWeatherLocation(this.currentBuildingId, String(this.itemToEdit!.id), payload)
      : this.severeWeatherLocationService.createSevereWeatherLocation(this.currentBuildingId, payload);

    request$.subscribe({
      next: (response) => {
        this.loading = false;
        if (!response.has_error) {
          this.onSave.emit({ type: 'success', message: this.isEdit ? 'This occurred after updating a location.' : 'This occurred after adding a location.' });
        } else {
          this.onSave.emit({ type: 'unsuccess', message: response.message });
        }
      },
      error: (err) => {
        this.loading = false;
        this.onSave.emit({ type: 'unsuccess', message: err.message });
      }
    });
  }
}
